import type { IconProps } from './types';

export function Tricot({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M76 80 Q88 76 100 80 Q116 60 128 56 Q140 60 156 80 Q168 76 180 80 Q204 92 228 120 Q220 128 208 124 Q198 116 188 108 L188 208 Q188 216 180 216 L76 216 Q68 216 68 208 L68 108 Q58 116 48 124 Q36 128 28 120 Q52 92 76 80 Z" />
      <path d="M88 132 Q108 152 128 132 Q148 152 168 132" />
      <path d="M88 172 Q108 192 128 172 Q148 192 168 172" />
    </svg>
  );
}
